import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import {
  CHANGE_SOUNDCASTS_ORDER,
  CHANGE_BUNDLES_ORDER,
  CHANGE_BUNDLE_SOUNDCASTS_ORDER,
} from '../actions/types';

const dashboardSoundcastIds = handleActions(
  {
    [CHANGE_SOUNDCASTS_ORDER]: (state, { payload }) =>
      isEmpty(payload) ? {} : merge({}, omit(state, Object.keys(payload)), payload),
  },
  {}
);

const dashboardBundleIds = handleActions(
  {
    [CHANGE_BUNDLES_ORDER]: (state, { payload }) =>
      isEmpty(payload) ? {} : merge({}, omit(state, Object.keys(payload)), payload),
  },
  {}
);

const dashboardBundleSoundcastIds = handleActions(
  {
    [CHANGE_BUNDLE_SOUNDCASTS_ORDER]: (state, { payload }) =>
      isEmpty(payload) ? {} : merge({}, omit(state, Object.keys(payload)), payload),
  },
  {}
);

export default combineReducers({
  dashboardSoundcastIds,
  dashboardBundleIds,
  dashboardBundleSoundcastIds,
});
